const initState = {};

export default (state = initState, { type, payload }) => {
  switch (type) {
    default:
      return state;
  }
};
